import { AxiosInstance } from 'axios';
import { DutyOrdersRepository } from '@/model/repository/shift/DutyOrdersRepository';

export default (Repository: AxiosInstance) =>
  (resource: string): DutyOrdersRepository => ({
    update(payload) {
      return Repository.put(resource, payload);
    },
  });
